import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=4a3b9b40"
import script from "./CategoryForm.vue?vue&type=script&lang=js"
export * from "./CategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a3b9b40')) {
      api.createRecord('4a3b9b40', component.options)
    } else {
      api.reload('4a3b9b40', component.options)
    }
    module.hot.accept("./CategoryForm.vue?vue&type=template&id=4a3b9b40", function () {
      api.rerender('4a3b9b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/shop/CategoryForm.vue"
export default component.exports